<template>
  <!-- <img src="@/assets/nc_left.svg" class="back-button" @click="back" /> -->
    <CustomIcon
    class="back-dse"
    style="width: 30px; height: 30px; border-radius: 50%"
     @click="back"
      :config="{
        attr: {
          cic_tp: 1,
          cic_sz: 18,
          cic_url: 'left',
          cic_c: 'var(--color-text)',
        },
      }"
    />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import CustomIcon from 'd3components/src/components/item-d3/d3/d3_customIcon.vue';
export default defineComponent({
  name: 'BackButton',
  components: {
    CustomIcon,
  },
  setup() {
    const router = useRouter();
    const isWechat = /MicroMessenger/i.test(navigator.userAgent);
    const isBrowserEnv = typeof window !== 'undefined' && typeof navigator !== 'undefined';

    const back = () => {
      router.back();
    };

    onMounted(() => {
      // 在可用浏览器环境统一挂载样式，避免页面逐个写环境判断
      if (isWechat || isBrowserEnv) {
        document.body.classList.add('is-wechat');
      }
    });

    return {
      back,
    };
  },
});
</script>

<style scoped>
.back-button {
  /* width: 26px;
  height: 30px; */
  /* color: #fff; */
  /* background: aqua; */
  /* 实现颜色反转 */
  /* filter: invert(1);
  mix-blend-mode: screen; */
  /* mix-blend-mode: difference; */
  filter: none;
}
.back-dse {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 80ms, background-color 120ms;
  transform: translateZ(0);
  will-change: box-shadow, transform, background-color;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

/* 仅在支持 hover 的设备启用，避免移动端长按后 hover 粘滞 */
@media (hover: hover) and (pointer: fine) {
  .back-dse:hover {
    background-color: color-mix(in srgb, var(--color-auth-icon) 30%, transparent);
    transform: scale(1.05);
  }
}

.back-dse:active {
  /* 触屏与鼠标按下都显示背景反馈 */
  background-color: color-mix(in srgb, var(--color-auth-icon) 30%, transparent);
  transform: scale(0.95);
  transition: transform 0.04s; /* 更快的点击反馈 */
}
</style>